import React, { Dispatch } from 'react';
import { createContext, useContext, useContextSelector } from 'use-context-selector';
import { IActions } from './MovementEnquiry.actions';
import reducer, { initialState, IState } from './MovementEnquiry.reducer';

export const MovementEnquiryStateContext = createContext<IState>(initialState);
export const MovementEnquiryDispatchContext = createContext<Dispatch<IActions>>(() => null);

export const useMEDispatch = () => useContext(MovementEnquiryDispatchContext);
export const useMEState = () => useContext(MovementEnquiryStateContext);
export const useMEContextSelector = <K extends keyof IState>(selector: (state: IState) => IState[K]) => useContextSelector<IState, IState[K]>(MovementEnquiryStateContext, selector);

interface IMovementEnquiryStateProvider {
  children: React.ReactNode;
}

const MovementEnquiryStateProvider = ({ children }: IMovementEnquiryStateProvider) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  return (
    <MovementEnquiryStateContext.Provider value={state}>
      <MovementEnquiryDispatchContext.Provider value={dispatch}>
        {children}
      </MovementEnquiryDispatchContext.Provider>
    </MovementEnquiryStateContext.Provider>
  );
};

export default MovementEnquiryStateProvider;
